module.exports = __webpack_public_path__ + "static/media/02-banner-04-perisur-mobile@2x.0cd0fcf7.jpg";